/* ===== Livia — scripts propios (vanilla) ===== */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.lv-reveal:not(.lv-visible), .lv-hero__media:not(.lv-visible)');
    if (!els.length) return;
    var design = window.Shopify && window.Shopify.designMode;
    if (reduce || design || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('lv-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('lv-visible'); observer.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  function initHeader() {
    var header = document.querySelector('.lv-header');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('lv-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var menu = document.querySelector('.lv-mobile-menu');
    var open = document.querySelector('[data-lv-menu-open]');
    var close = document.querySelector('[data-lv-menu-close]');
    if (!menu || !open) return;
    function setMenu(state) {
      menu.classList.toggle('lv-open', state);
      open.setAttribute('aria-expanded', state ? 'true' : 'false');
      document.body.style.overflow = state ? 'hidden' : '';
    }
    open.addEventListener('click', function () { setMenu(true); });
    if (close) close.addEventListener('click', function () { setMenu(false); });
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
  }

  function initCarruseles() {
    document.querySelectorAll('[data-lv-carousel]').forEach(function (wrap) {
      if (wrap.dataset.lvReady) return;
      wrap.dataset.lvReady = '1';
      var track = wrap.querySelector('.lv-track');
      if (!track) return;
      wrap.querySelectorAll('[data-lv-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = track.querySelector(':scope > *');
          var step = card ? card.getBoundingClientRect().width + 20 : 320;
          track.scrollBy({ left: step * Number(btn.dataset.lvDir), behavior: 'smooth' });
        });
      });
    });
  }

  function initProducto() {
    var root = document.querySelector('[data-lv-product]');
    if (!root || root.dataset.lvReady) return;
    root.dataset.lvReady = '1';

    // Galería
    var main = root.querySelector('[data-lv-main]');
    var thumbs = root.querySelectorAll('[data-lv-thumb]');
    function showImage(src, srcset, btn) {
      if (!main || !src) return;
      main.src = src;
      if (srcset) main.srcset = srcset;
      thumbs.forEach(function (t) { t.classList.toggle('lv-active', t === btn); });
      var idx = Array.prototype.indexOf.call(thumbs, btn);
      var counter = root.querySelector('[data-lv-count]');
      if (counter && idx > -1) counter.textContent = (idx + 1) + ' / ' + thumbs.length;
    }
    function current() {
      var i = 0;
      thumbs.forEach(function (t, n) { if (t.classList.contains('lv-active')) i = n; });
      return i;
    }
    function go(step) {
      if (!thumbs.length) return;
      var n = (current() + step + thumbs.length) % thumbs.length;
      var t = thumbs[n];
      showImage(t.dataset.src, t.dataset.srcset, t);
      if (t.scrollIntoView) { try { t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {} }
    }
    root.querySelectorAll('[data-lv-gal]').forEach(function (b) {
      b.addEventListener('click', function () { go(Number(b.dataset.lvGal)); });
    });
    var cnt0 = root.querySelector('[data-lv-count]');
    if (cnt0) cnt0.textContent = (current() + 1) + ' / ' + thumbs.length;
    var stage = root.querySelector('[data-lv-stage]');
    if (stage) {
      var x0 = null, y0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) go(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showImage(t.dataset.src, t.dataset.srcset, t); });
    });

    // Variantes
    var dataEl = root.querySelector('[data-lv-variants]');
    var variants = [];
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) { variants = []; }
    var form = root.querySelector('form');
    var idInput = form && form.querySelector('input[name="id"]');
    var btn = root.querySelector('[data-lv-add]');
    var priceEl = root.querySelector('[data-lv-price]');
    var msg = root.querySelector('[data-lv-msg]');
    var labels = root.querySelectorAll('[data-lv-optvalue]');
    var textAdd = btn ? btn.dataset.textAdd : '';
    var textSold = btn ? btn.dataset.textSold : '';
    var textNa = btn ? btn.dataset.textNa : '';

    function selected() {
      var out = [];
      root.querySelectorAll('[data-lv-opt]').forEach(function (group) {
        var chk = group.querySelector('input:checked');
        out.push(chk ? chk.value : null);
      });
      return out;
    }
    function findVariant(sel) {
      return variants.find(function (v) {
        return sel.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }
    function update(userChange) {
      var sel = selected();
      var v = findVariant(sel);
      labels.forEach(function (input) { input.classList.remove('lv-na'); });
      // Marca combinaciones agotadas
      root.querySelectorAll('[data-lv-opt]').forEach(function (group, gi) {
        group.querySelectorAll('input').forEach(function (input) {
          var test = sel.slice(); test[gi] = input.value;
          var vv = findVariant(test);
          if (!vv || !vv.available) input.classList.add('lv-na');
        });
      });
      if (!v) {
        if (btn) { btn.disabled = true; btn.querySelector('span').textContent = textNa; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.compare ? '<s>' + v.compare + '</s><span>' + v.price + '</span>' : '<span>' + v.price + '</span>';
      var sp = document.querySelector('[data-lv-sticky-price]');
      if (sp) sp.textContent = v.price;
      if (btn) {
        btn.disabled = !v.available;
        btn.querySelector('span').textContent = v.available ? textAdd : textSold;
      }
      if (v.image && userChange === true) {
        var match = null;
        thumbs.forEach(function (t) { if (t.dataset.imgid && String(t.dataset.imgid) === String(v.imageId)) match = t; });
        if (match) showImage(match.dataset.src, match.dataset.srcset, match);
      }
      root.querySelectorAll('[data-lv-optname]').forEach(function (n, i) { if (v.options[i]) n.textContent = v.options[i]; });
      if (msg) msg.textContent = '';
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.querySelectorAll('[data-lv-opt] input').forEach(function (i) { i.addEventListener('change', function () { update(true); }); });
    update();

    // Fecha estimada de entrega (días laborables a partir de hoy)
    var ent = root.querySelector('[data-lv-entrega]');
    if (ent) {
      var addBiz = function (n) {
        var d = new Date();
        while (n > 0) { d.setDate(d.getDate() + 1); var g = d.getDay(); if (g !== 0 && g !== 6) n--; }
        return d;
      };
      try {
        var fmt = new Intl.DateTimeFormat('es-ES', { weekday: 'long', day: 'numeric', month: 'long' });
        var f1 = addBiz(Number(ent.dataset.min)), f2 = addBiz(Number(ent.dataset.max));
        var el = ent.querySelector('[data-lv-fecha]');
        if (el) el.textContent = 'entre el ' + fmt.format(f1) + ' y el ' + fmt.format(f2);
      } catch (e) {}
    }

    // Barra de compra fija: aparece cuando el botón principal sale de la pantalla
    var bar = document.querySelector('[data-lv-sticky]');
    var buyBox = root.querySelector('.lv-buy');
    if (bar && buyBox && 'IntersectionObserver' in window) {
      var barBtn = bar.querySelector('[data-lv-sticky-add]');
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var on = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('lv-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (barBtn) barBtn.tabIndex = on ? 0 : -1;
      }).observe(buyBox);
      if (barBtn && btn) barBtn.addEventListener('click', function () { if (!btn.disabled) btn.click(); });
    }

    // Cantidad
    var qty = root.querySelector('[data-lv-qty]');
    if (qty) {
      var input = qty.querySelector('input');
      qty.querySelector('[data-lv-minus]').addEventListener('click', function () { input.value = Math.max(1, Number(input.value) - 1); });
      qty.querySelector('[data-lv-plus]').addEventListener('click', function () { input.value = Number(input.value) + 1; });
    }
  }


  /* ===== Popup de bienvenida (−10 %) =====
     A los 3 s (o cuando la persona cierre el aviso de cookies). Se acuerda de quién lo cerró o se suscribió. */
  function initPopup() {
    var pop = document.querySelector('[data-lv-pop]');
    if (!pop || pop.dataset.lvReady) return;
    pop.dataset.lvReady = '1';

    var KEY = 'lv_pop_v1';
    var code = pop.dataset.code || '';
    var delay = Number(pop.dataset.delay) || 3000;
    var days = Number(pop.dataset.days) || 14;
    var form = pop.querySelector('form');
    var email = pop.querySelector('[data-lv-pop-email]');
    var consent = pop.querySelector('[data-lv-pop-consent]');
    var err = pop.querySelector('[data-lv-pop-err]');
    var submit = pop.querySelector('[data-lv-pop-submit]');
    var lastFocus = null;
    var isOpen = false;

    function read() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
    function write(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }

    function focusables() {
      return Array.prototype.filter.call(
        pop.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])'),
        function (el) { return el.offsetParent !== null; }
      );
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function useLink() {
      var a = pop.querySelector('[data-lv-pop-use]');
      if (!a) return;
      var back = (window.location.pathname.indexOf('/checkouts') === 0) ? '/' : window.location.pathname + window.location.search;
      a.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back);
    }
    function open() {
      if (isOpen) return;
      isOpen = true;
      lastFocus = document.activeElement;
      useLink();
      pop.setAttribute('aria-hidden', 'false');
      pop.classList.add('lv-pop--on');
      document.body.classList.add('lv-pop-open');
      document.addEventListener('keydown', onKey);
      setTimeout(function () {
        var target = pop.classList.contains('lv-pop--done') ? pop.querySelector('[data-lv-pop-copy]') : email;
        if (target) { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }
      }, 350);
    }
    function close() {
      if (!isOpen) return;
      isOpen = false;
      pop.classList.remove('lv-pop--on');
      pop.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lv-pop-open');
      document.removeEventListener('keydown', onKey);
      var st = read();
      if (st.s !== 'done') write({ s: 'closed', t: Date.now() });
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    }
    function showDone() {
      pop.classList.add('lv-pop--done');
      write({ s: 'done', t: Date.now() });
      useLink();
      document.querySelectorAll('[data-lv-open-pop] span').forEach(function (n) { n.textContent = 'Ver mi código'; });
      // Deja el código listo para el pago (si el código existe en Shopify, se aplica solo)
      try { fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }); } catch (e) {}
      try { if (window.fbq) window.fbq('track', 'Lead'); } catch (e) {}
    }

    pop.querySelectorAll('[data-lv-pop-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.querySelectorAll('[data-lv-open-pop]').forEach(function (b) { b.addEventListener('click', function () { if (read().s === 'done') pop.classList.add('lv-pop--done'); open(); }); });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = (email.value || '').trim();
        var okMail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
        email.setAttribute('aria-invalid', okMail ? 'false' : 'true');
        if (!okMail) { err.textContent = 'Escribe un email válido para enviarte el código.'; email.focus(); return; }
        if (consent && !consent.checked) { err.textContent = 'Marca la casilla para poder enviarte el código y las novedades.'; consent.focus(); return; }
        err.textContent = '';
        submit.disabled = true;
        var done = function () { submit.disabled = false; showDone(); };
        try {
          fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' }).then(done, done);
        } catch (x) { done(); }
      });
      email.addEventListener('input', function () { email.setAttribute('aria-invalid', 'false'); err.textContent = ''; });
    }

    var copy = pop.querySelector('[data-lv-pop-copy]');
    if (copy) copy.addEventListener('click', function () {
      var fin = function () { copy.textContent = 'Copiado'; setTimeout(function () { copy.textContent = 'Copiar'; }, 2200); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(fin, fin);
      else {
        var t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select();
        try { document.execCommand('copy'); } catch (x) {} document.body.removeChild(t); fin();
      }
    });

    // Salida automática
    if (window.Shopify && window.Shopify.designMode) return;
    var st = read();
    if (st.s === 'done') { pop.classList.add('lv-pop--done'); document.querySelectorAll('[data-lv-open-pop] span').forEach(function (n) { n.textContent = 'Ver mi código'; }); return; }
    if (st.s === 'closed' && st.t && (Date.now() - st.t) < days * 86400000) return;

    function bannerVisible() {
      var b = document.getElementById('shopify-pc__banner');
      return !!(b && b.offsetParent !== null);
    }
    function busy() { return document.querySelector('.lv-mobile-menu.lv-open') || bannerVisible(); }
    var waited = false;
    function attempt() {
      if (isOpen) return;
      if (busy()) { waited = true; setTimeout(attempt, 700); return; }
      if (waited) { waited = false; setTimeout(attempt, 1200); return; }
      open();
    }
    setTimeout(attempt, delay);
  }

  function init() { initReveal(); initHeader(); initCarruseles(); initProducto(); initPopup(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initCarruseles(); initProducto(); });
})();
